<template>
    <div class="homejieshao">
        <div style="display: flex;">
            <img src="../../../assets/aboutus.jpg" alt="">
            <div class="homejieshao1">
                <img src="../../../assets/vertical-line.png" alt="" style="">
                <h2>集团简介</h2>
                <div v-html="getProfile.introduction">
               
            </div>
                <p  @click="openNewAll" style="margin-top: 20px;float: right;color: red;cursor: pointer;" >>>></p>
            </div>
        </div>
        <div style="display: flex;">
            <div class="homejieshao2">
            <img src="../../../assets/vertical-line.png" alt="" style="">
            <h2>企业文化</h2>
            <div v-html="getProfile.culture">
               
            </div>
        </div>
        <img src="../../../assets/about3.jpg" alt="">
        </div>
        
    </div>
  </template>
  
  
  <script>
  export default {
    components: {
    },
    name: "homejieshao",
    data() {
      return {
        getProfile:'',
      }
    },
    mounted() {
        this.$axios
            .get("/system/profile/getProfile", {})
            .then(res => {
                if (res.code == 0) {
                this.getProfile = res.data[0]
                } else {
                this.$message.closeAll();
                this.$message.error(res.msg);
                }
            });
     
    },
    methods: {
        openNewAll(row){
            sessionStorage.setItem("top", '1');
            this.$router.push({
            path: "/schoolProfile",
        });
        },
    }
  };
  </script>
  
  <style lang="less">
  .homejieshao {
    width: 1200px;
    margin: 0 auto;
    margin-top: 100px;
    .homejieshao1{
        padding: 0 0 50px 100px;
        color:#222222;
        position: relative;
        margin-left: 100px;
        img{
            position: absolute;
            left: 0;
            top: 0;
        }
        h2{
            font-size: 30px;
            line-height: 60px;
        }
        div{
            line-height: 40px;
            font-size: 18px;
            color:#222222
        }
    }
    .homejieshao2{
        padding: 0 100px 50px 0;
        margin-top: 50px;
        color:#222222;
        position: relative;
        margin-right: 100px;
        img{
            position: absolute;
            right: 0;
            top: 0;
        }
        h2{
            font-size: 30px;
            line-height: 60px;
        }
        div{
            line-height: 40px;
            font-size: 18px;
            color:#222222
        }
    }
  }
  </style>